module.exports = __webpack_public_path__ + "media/images/icons/content-621b91c13be3e709da08b36beda9ec7b.png";